const state = {
	listOrderData: [],
	filter: {},
	page: 1,
	totalpage: 1,
	totalcount: 0,
	loading: false,
};

const getters = {
	getListData: (state) => {
		return state.listOrderData;
	},
	getTotalPage: (state) => {
		return state.totalpage;
	},
	getTotalCount: (state) => {
		return state.totalcount;
	},
	getPageNo: (state) => {
		return state.page;
	},
	isOrderLoading: (state) => {
		return state.loading;
	},
};

const mutations = {
	updateData: (state, payload) => {
		state.listOrderData = payload;
	},
	updateFilter: (state, payload) => {
		state.filter = payload;
	},
	updatePage: (state, payload) => {
		state.totalpage = payload;
	},
	updatePageNo: (state, payload) => {
		state.page = payload;
	},
	updateCount: (state, payload) => {
		state.totalcount = payload;
	},
	clearAll: (state, payload) => {
		state.listOrderData = [];
		state.filter = {};
		state.page = 1;
		
	},
	isLoading: (state, payload) => {
		state.loading = payload;
	},
};

const actions = {
	getData: ({ commit, dispatch, rootGetters }) => {
		
		commit('isLoading',true);
		
		let parameter = "?sessionid=" + rootGetters.sessionid;
		
		
		
		if (state.filter.provider != null && state.filter.provider != "") {
			parameter += "&provider=" + state.filter.provider;
		}
		
		if (state.filter.status != null && state.filter.status != "") {
			parameter += "&status=" + state.filter.status;
		}
		
		if (state.filter.sku != null && state.filter.sku != "") {
			parameter += "&sku=" + state.filter.sku;
		}
		
		if (state.filter.date != null && state.filter.date != "") {
			parameter += "&date=" + state.filter.date;
		}
		
		if (state.filter.keyword_criteria != null && state.filter.keyword_criteria != "") {
			parameter += "&keyword_criteria=" + state.filter.keyword_criteria;
		}
		
		if (state.filter.keyword != null && state.filter.keyword != "") {
			parameter += "&keyword=" + state.filter.keyword;
		}
		
		if (state.page != null  && state.page != "") {
			parameter += "&page=" + state.page;
		}
		
		fetch(process.env.VUE_APP_LIST + parameter)
			.then((data) => data.json())
			.then((data) => {
				commit('updateData', data.data);
				commit('updatePage', parseInt(data.totalpage));
				commit('updateCount', parseInt(data.totalcount));
				commit('isLoading',false);
			})
			.catch((err) => {
				//window.alert('error - see dev console for more details');
				console.error(err);
				commit('isLoading',false);
			});
	},
	setFilter: ({ commit }, req) => {
		commit('updateFilter',req);
		
		
	},
	setPage: ({ commit }, req) => {
		commit('updatePageNo',req);
		
		
	},
};

export default {
	state,
	mutations,
	getters,
	actions,
};
